module.exports = __webpack_public_path__ + "img/header_logo_nisum.91c6f503.webp";